export default __webpack_public_path__ + "static/media/min-venn.8cb61b49.svg";